module.exports = __webpack_public_path__ + "media/images/ticket/close_ov-e041abd4d0d9dd4f7d6231bfab6406c3.png";